import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import { connect } from "react-redux";
import productsService from "../../services/products";
import authService from "../../services/auth";
import orderItemsService from "../../services/order-items";
import productStockWaitlistService from "../../services/product-stock-waitlist";

import Product from "../product/Product";
import DialogBase from "./DialogBase";
import SetOrderItemQty from "../commons/SetOrderItemQty";
import { BellIcon, CheckPlainIcon } from "../commons/Icons";
import { DialogContent, Box, Button, Typography } from "@mui/material";

class DialogProduct extends React.Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    this.state = {
      subscribed: false,
      loading_waitlist: false,
    };
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  subscribeWaitlist() {
    const { id_profile, product } = this.props;
    this._isMounted && this.setState({ loading_waitlist: true });
    productStockWaitlistService
      .subscribe(id_profile, product.ID)
      .then(() => {
        this._isMounted && this.setState({ subscribed: true });
      })
      .catch((error) => {
        this.props.onError && this.props.onError(error);
      })
      .finally(() => {
        this._isMounted && this.setState({ loading_waitlist: false });
      });
  }

  render() {
    const { classes, open, onClose, id_profile, product, order_items, onOrderItemsChange, appStore, ...others } =
      this.props;
    const { subscribed, loading_waitlist } = this.state;

    const authProfile = appStore?.authProfile;
    const is_outofstock = product?.state === productsService.META_STATE_OUTOFSTOCK;
    const is_blocked = is_outofstock && !product?.stock_allow_backorder;
    const is_provider = authService.isLoggedInProfile(id_profile);
    const is_customer = authProfile && !is_provider;

    const show_waitlist_btn = is_blocked && is_customer;
    const show_order_qty = !!order_items && !is_blocked;
    const stock_qty_label =
      product?.stock_enabled && !is_outofstock && product?.stock_qty != null
        ? "Stock : " +
          product.stock_qty +
          (product.format === productsService.META_FORMAT_BULK && product.volume_unit ? " " + product.volume_unit : "")
        : null;
    const stock_below_threshold =
      stock_qty_label != null &&
      product?.stock_alert_threshold != null &&
      product.stock_qty < product.stock_alert_threshold;
    const stock_deficit_label =
      is_provider && product?.stock_enabled && is_outofstock && product?.stock_qty != null
        ? "(" +
          product.stock_qty +
          (product.format === productsService.META_FORMAT_BULK && product.volume_unit ? " " + product.volume_unit : "") +
          ")"
        : null;

    const scrollableTargetId = "dialog-product";
    return (
      <DialogBase maxWidth="xs" open={open} onClose={onClose}>
        <DialogContent classes={{ root: classes.dialogContent }} id={scrollableTargetId}>
          <Product
            id_profile={id_profile}
            product={product}
            stock_qty_label={stock_qty_label}
            stock_below_threshold={stock_below_threshold}
            stock_deficit_label={stock_deficit_label}
            scrollableTarget={scrollableTargetId}
            {...others}
          />

          {(show_waitlist_btn || show_order_qty) && (
            <Box className={classes.footer}>
              {show_waitlist_btn &&
                (subscribed ? (
                  <Box className={classes.subscribed}>
                    <CheckPlainIcon className={classes.subscribed_icon} />
                    <Typography variant="body2" className={classes.subscribed_msg}>
                      Vous serez notifié(e) dès que ce produit est de nouveau disponible.
                    </Typography>
                  </Box>
                ) : (
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    startIcon={<BellIcon />}
                    disabled={loading_waitlist}
                    onClick={() => this.subscribeWaitlist()}
                  >
                    M&apos;avertir quand disponible
                  </Button>
                ))}

              {show_order_qty && (
                <Box className={classes.order_qty}>
                  <SetOrderItemQty
                    order_item={orderItemsService.getForProduct(order_items, product)}
                    onChange={(order_item) => {
                      const updatedOrderItems = orderItemsService.getUpdatedOrderItems(order_items, order_item);
                      onOrderItemsChange && onOrderItemsChange(updatedOrderItems);
                    }}
                  />
                </Box>
              )}
            </Box>
          )}
        </DialogContent>
      </DialogBase>
    );
  }
}

const styles = (theme) => ({
  dialogContent: {
    padding: 0,
    backgroundColor: theme.palette.bg.light,
  },
  footer: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.bg.white,
    borderTop: `1px solid ${theme.palette.bg.light}`,
  },
  order_qty: {
    display: "flex",
    justifyContent: "flex-end",
  },
  subscribed: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  subscribed_icon: {
    color: theme.palette.primary.main,
  },
  subscribed_msg: {
    textAlign: "center",
  },
});

DialogProduct.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  id_profile: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  product: PropTypes.object.isRequired,
  order_items: PropTypes.array,
  onOrderItemsChange: PropTypes.func,
  onError: PropTypes.func,
  onSuccess: PropTypes.func,
};

const mapStateToProps = (state) => ({
  appStore: state.app,
});

export default withStyles(styles, { withTheme: true })(connect(mapStateToProps)(DialogProduct));
